import React, { FC } from "react"

import { Select, SelectProps } from "@mantine/core"

import useOrganisationsSelect from "./useOrganisationsSelect"

type OrganisationsSelectProps = Omit<SelectProps, "data">

const OrganisationsSelect: FC<OrganisationsSelectProps> = ({ ...props }) => {
    const { data, loading } = useOrganisationsSelect()

    return <Select data={data} disabled={loading} withinPortal={true} {...props} />
}

export default OrganisationsSelect
